import ClickSyncProcessManagementClickSyncProcessListSlice from '../../slices/experiences/ClickSyncProcessManagementClickSyncProcessListSlice'
import ClickSyncProcessManagementClickSyncProcessListExportSlice from '../../slices/experiences/ClickSyncProcessManagementClickSyncProcessListExportSlice'

const ClickSyncProcessManagementExperienceActions = {
  list: ClickSyncProcessManagementClickSyncProcessListSlice.actions,
  exportList: ClickSyncProcessManagementClickSyncProcessListExportSlice.actions
}

export default ClickSyncProcessManagementExperienceActions
